<template>
  <span class="tags">
    <el-tag
    v-for="(item, index) in data"
    :key="index"
    :type="types[index%types.length]"
  >{{item}}</el-tag>
  </span>
</template>

<script>
export default {
  props: {
    data: {
      type: Array,
      default: () => []
    },
    types: {
      type: Array,
      default: () => ['success', 'warning', 'info']
    }
  }
}
</script>

<style lang="less" scoped>
  .tags .el-tag{
    margin: 0 4px;
  }
</style>
